
import React from 'react';
import { Award } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const CertificationsTabContent: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Award className="h-5 w-5 text-primary" />
          Certifications
        </CardTitle>
        <CardDescription>
          Showcase your expertise with professional certifications
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-center py-10">
          <Award className="h-16 w-16 mx-auto mb-4 text-primary/20" />
          <p className="text-muted-foreground mb-6">Complete courses to earn certifications</p>
          <Button variant="outline">Browse Certification Programs</Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CertificationsTabContent;
